<div class="form-layout-compact">
    @if (displayField) {
        <div class="lm-add-alert-menu">
            <button
                type="button"
                id="add-Alert"
                data-automation-id="lm-builder-display-field-add-alert-btn"
                soho-menu-button
                icon="add"
                menu="addAlertMenu"
                [autoFocus]="true"
                [disabled]="displayField.alerts.red && displayField.alerts.yellow && displayField.alerts.green && displayField.alerts.blue">{{ 'Add' | translate }}</button>
            <ul soho-popupmenu id="addAlertMenu">
                @if (!displayField.alerts.red) {
                    <li soho-popupmenu-item>
                        <a soho-popupmenu-label data-automation-id="lm-builder-red-alert-menuitem" (click)="addAlert('red')">{{ 'RedAlert' | translate }}</a>
                    </li>
                }
                @if (!displayField.alerts.yellow) {
                    <li soho-popupmenu-item>
                        <a soho-popupmenu-label data-automation-id="lm-builder-yellow-alert-menuitem" (click)="addAlert('yellow')">{{ 'YellowAlert' | translate }}</a>
                    </li>
                }
                @if (!displayField.alerts.green) {
                    <li soho-popupmenu-item>
                        <a soho-popupmenu-label data-automation-id="lm-builder-green-alert-menuitem" (click)="addAlert('green')">{{ 'GreenAlert' | translate }}</a>
                    </li>
                }
                @if (!displayField.alerts.blue) {
                    <li soho-popupmenu-item>
                        <a soho-popupmenu-label data-automation-id="lm-builder-blue-alert-menuitem" (click)="addAlert('blue')">{{ 'BlueAlert' | translate }}</a>
                    </li>
                }
            </ul>
        </div>
        @if (displayField.alerts.red) {
            <div class="lm-builder-alert-container">
                <div class="lm-builder-alert-header">
                    <svg id="lm-display-field-red-alert-type" class="icon-error icon lm-builder-alert-icon" role="presentation" soho-tooltip [content]="'RedAlert' | translate">
                        <use href="#icon-error"></use>
                    </svg>
                    <p data-automation-id="lm-builder-display-field-red-alert-header" class="heading">{{ 'RedAlert' | translate }}</p>
                    <a (click)="removeAlert('red')">
                        <svg id="lm-builder-display-field-red-alert-remove-icon" data-automation-id="lm-builder-display-field-red-alert-remove-icon" class="lm-builder-alert-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                    </a>
                </div>
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-red-alert-when">{{ 'ShowWhen' | translate }}</label>
                    <input
                           id="lm-display-field-red-alert-when"
                           data-automation-id="lm-display-field-red-alert-when"
                           soho-lookup
                           soho-trackdirty
                           soho-alert
                           data-validate="validateRequired"
                           [click]="lookupRedClick"
                           [(ngModel)]="displayField.alerts.red.when.condition"
                           (ngModelChange)="conditionValidator$.next({ type: 'red', simpleCondition: $event })"/>
                </div>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-red-alert-not-negated"
                       data-automation-id="lm-builder-display-field-red-alert-not-negated"
                       [value]=false
                       [(ngModel)]="displayField.alerts.red.when.negated"
                       (ngModelChange)="updateNegated(false, 'red')"/>
                <label soho-label for="lm-builder-display-field-red-alert-not-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsTrue' | translate }}</label>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-red-alert-negated"
                       data-automation-id="lm-builder-display-field-red-alert-negated"
                       [value]=true
                       [(ngModel)]="displayField.alerts.red.when.negated"
                       (ngModelChange)="updateNegated(true, 'red')"/>
                <label soho-label for="lm-builder-display-field-red-alert-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsFalse' | translate }}</label>
<!--                <div class="field">-->
<!--                    <input-->
<!--                            soho-checkbox-->
<!--                            type="checkbox"-->
<!--                            id="lm-builder-display-field-red-alert-negate"-->
<!--                            data-automation-id="lm-builder-display-field-red-alert-negate-input"-->
<!--                            soho-trackdirty-->
<!--                            [(ngModel)]="displayField.alerts.red.when.negated">-->
<!--                    <label soho-label for="lm-builder-display-field-red-alert-negate" [forCheckBox]="true" data-automation-id="lm-builder-display-field-red-alert-negate-label">Show when false</label>-->
<!--                </div>-->
                <div class="field">
                    <label soho-label for="lm-display-field-red-alert-mouse-over-text">{{ 'Message' | translate }}</label>
                    <input
                            id="lm-display-field-red-alert-mouse-over-text"
                            data-automation-id="lm-display-field-red-alert-mouse-over-text-input"
                            soho-input
                            soho-trackdirty
                            class=""
                            [(ngModel)]="redAlertMessage"
                            (ngModelChange)="updateMessage('red')">
                </div>
            </div>
        }
        @if (displayField.alerts.yellow) {
            <div class="lm-builder-alert-container">
                <div class="lm-builder-alert-header">
                    <svg id="lm-display-field-yellow-alert-type" class="icon-warning icon lm-builder-alert-icon" role="presentation" soho-tooltip [content]="'YellowAlert' | translate">
                        <use href="#icon-alert"></use>
                    </svg>
                    <p data-automation-id="lm-builder-display-field-yellow-alert-header" class="heading">{{ 'YellowAlert' | translate }}</p>
                    <a (click)="removeAlert('yellow')">
                        <svg id="lm-builder-display-field-yellow-alert-remove-icon" data-automation-id="lm-builder-display-field-yellow-alert-remove-icon" class="lm-builder-alert-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                    </a>
                </div>
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-yellow-alert-when">{{ 'ShowWhen' | translate }}</label>
                    <input
                            id="lm-display-field-yellow-alert-when"
                            data-automation-id="lm-display-field-yellow-alert-when"
                            soho-lookup
                            soho-trackdirty
                            soho-alert
                            data-validate="validateRequired"
                            [click]="lookupYellowClick"
                            [(ngModel)]="displayField.alerts.yellow.when.condition"
                            (ngModelChange)="conditionValidator$.next( { type: 'yellow', simpleCondition: $event })"/>
                </div>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-yellow-alert-not-negated"
                       data-automation-id="lm-builder-display-field-yellow-alert-not-negated"
                       [value]=false
                       [(ngModel)]="displayField.alerts.yellow.when.negated"
                       (ngModelChange)="updateNegated(false, 'yellow')"/>
                <label soho-label for="lm-builder-display-field-yellow-alert-not-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsTrue' | translate }}</label>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-yellow-alert-negated"
                       data-automation-id="lm-builder-display-field-yellow-alert-negated"
                       [value]=true
                       [(ngModel)]="displayField.alerts.yellow.when.negated"
                       (ngModelChange)="updateNegated(true, 'yellow')"/>
                <label soho-label for="lm-builder-display-field-yellow-alert-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsFalse' | translate }}</label>
                <div class="field">
                    <label soho-label for="lm-display-field-yellow-alert-mouse-over-text">{{ 'Message' | translate }}</label>
                    <input
                            id="lm-display-field-yellow-alert-mouse-over-text"
                            data-automation-id="lm-display-field-yellow-alert-mouse-over-text-input"
                            soho-input
                            soho-trackdirty
                            class=""
                            [(ngModel)]="yellowAlertMessage"
                            (ngModelChange)="updateMessage('yellow')">
                </div>
<!--                <div class="field">-->
<!--                    <input-->
<!--                            soho-checkbox-->
<!--                            type="checkbox"-->
<!--                            id="lm-builder-display-field-yellow-alert-negate"-->
<!--                            data-automation-id="lm-builder-display-field-yellow-alert-negate-input"-->
<!--                            soho-trackdirty-->
<!--                            [(ngModel)]="displayField.alerts.yellow.when.negated">-->
<!--                    <label soho-label for="lm-builder-display-field-yellow-alert-negate" [forCheckBox]="true" data-automation-id="lm-builder-display-field-yellow-alert-negate-label">Show when false</label>-->
<!--                </div>-->
            </div>
        }
        @if (displayField.alerts.green) {
            <div class="lm-builder-alert-container">
                <div class="lm-builder-alert-header">
                    <svg id="lm-display-field-green-alert-type" class="icon-success icon lm-builder-alert-icon" role="presentation" soho-tooltip [content]="'GreenAlert' | translate">
                        <use href="#icon-success"></use>
                    </svg>
                    <p data-automation-id="lm-builder-display-field-green-alert-header" class="heading">{{ 'GreenAlert' | translate }}</p>
                    <a (click)="removeAlert('green')">
                        <svg id="lm-builder-display-field-green-alert-remove-icon" data-automation-id="lm-builder-display-field-green-alert-remove-icon" class="lm-builder-alert-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                    </a>
                </div>
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-green-alert-when">{{ 'ShowWhen' | translate }}</label>
                    <input
                            id="lm-display-field-green-alert-when"
                            data-automation-id="lm-display-field-green-alert-when"
                            soho-lookup
                            soho-trackdirty
                            soho-alert
                            data-validate="validateRequired"
                            [click]="lookupGreenClick"
                            [(ngModel)]="displayField.alerts.green.when.condition"
                            (ngModelChange)="conditionValidator$.next({ type: 'green', simpleCondition: $event })"/>
                </div>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-green-alert-not-negated"
                       data-automation-id="lm-builder-display-field-green-alert-not-negated"
                       [value]=false
                       [(ngModel)]="displayField.alerts.green.when.negated"
                       (ngModelChange)="updateNegated(false, 'green')"/>
                <label soho-label for="lm-builder-display-field-green-alert-not-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsTrue' | translate }}</label>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-green-alert-negated"
                       data-automation-id="lm-builder-display-field-green-alert-negated"
                       [value]=true
                       [(ngModel)]="displayField.alerts.green.when.negated"
                       (ngModelChange)="updateNegated(true, 'green')"/>
                <label soho-label for="lm-builder-display-field-yellow-alert-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsFalse' | translate }}</label>
                <div class="field">
                    <label soho-label for="lm-display-field-green-alert-mouse-over-text">{{ 'Message' | translate }}</label>
                    <input
                            id="lm-display-field-green-alert-mouse-over-text"
                            data-automation-id="lm-display-field-green-alert-mouse-over-text-input"
                            soho-input
                            soho-trackdirty
                            class=""
                            [(ngModel)]="greenAlertMessage"
                            (ngModelChange)="updateMessage('green')">
                </div>
<!--                <div class="field">-->
<!--                    <input-->
<!--                            soho-checkbox-->
<!--                            type="checkbox"-->
<!--                            id="lm-builder-display-field-green-alert-negate"-->
<!--                            data-automation-id="lm-builder-display-field-green-alert-negate-input"-->
<!--                            soho-trackdirty-->
<!--                            [(ngModel)]="displayField.alerts.green.when.negated">-->
<!--                    <label soho-label for="lm-builder-display-field-green-alert-negate" [forCheckBox]="true" data-automation-id="lm-builder-display-field-green-alert-negate-label">Show when false</label>-->
<!--                </div>-->
            </div>
        }
        @if (displayField.alerts.blue) {
            <div class="lm-builder-alert-container">
                <div class="lm-builder-alert-header">
                    <svg id="lm-display-field-blue-alert-type" class="icon-info icon lm-builder-alert-icon" role="presentation" soho-tooltip [content]="'BlueAlert' | translate">
                        <use href="#icon-info"></use>
                    </svg>
                    <p data-automation-id="lm-builder-display-field-blue-alert-header" class="heading">{{ 'BlueAlert' | translate }}</p>
                    <a (click)="removeAlert('blue')">
                        <svg id="lm-builder-display-field-blue-alert-remove-icon" data-automation-id="lm-builder-display-field-blue-alert-remove-icon" class="lm-builder-alert-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                    </a>
                </div>
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-blue-alert-when">{{ 'ShowWhen' | translate }}</label>
                    <input
                            id="lm-display-field-blue-alert-when"
                            data-automation-id="lm-display-field-blue-alert-when"
                            soho-lookup
                            soho-trackdirty
                            soho-alert
                            data-validate="validateRequired"
                            [click]="lookupBlueClick"
                            [(ngModel)]="displayField.alerts.blue.when.condition"
                            (ngModelChange)="conditionValidator$.next({ type: 'blue', simpleCondition: $event })"/>
                </div>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-blue-alert-not-negated"
                       data-automation-id="lm-builder-display-field-blue-alert-not-negated"
                       [value]=false
                       [(ngModel)]="displayField.alerts.blue.when.negated"
                       (ngModelChange)="updateNegated(false, 'blue')"/>
                <label soho-label for="lm-builder-display-field-blue-alert-not-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsTrue' | translate }}</label>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-blue-alert-negated"
                       data-automation-id="lm-builder-display-field-blue-alert-negated"
                       [value]=true
                       [(ngModel)]="displayField.alerts.blue.when.negated"
                       (ngModelChange)="updateNegated(true, 'blue')"/>
                <label soho-label for="lm-builder-display-field-blue-alert-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsFalse' | translate }}</label>
                <div class="field">
                    <label soho-label for="lm-display-field-blue-alert-mouse-over-text">{{ 'Message' | translate }}</label>
                    <input
                            id="lm-display-field-blue-alert-mouse-over-text"
                            data-automation-id="lm-display-field-blue-alert-mouse-over-text-input"
                            soho-input
                            soho-trackdirty
                            class=""
                            [(ngModel)]="blueAlertMessage"
                            (ngModelChange)="updateMessage('blue')">
                </div>
<!--                <div class="field">-->
<!--                    <input-->
<!--                            soho-checkbox-->
<!--                            type="checkbox"-->
<!--                            id="lm-builder-display-field-blue-alert-negate"-->
<!--                            data-automation-id="lm-builder-display-field-blue-alert-negate-input"-->
<!--                            soho-trackdirty-->
<!--                            [(ngModel)]="displayField.alerts.blue.when.negated">-->
<!--                    <label soho-label for="lm-builder-display-field-blue-alert-negate" [forCheckBox]="true" data-automation-id="lm-builder-display-field-blue-alert-negate-label">Show when false</label>-->
<!--                </div>-->
            </div>
        }
        @if (displayField.alerts.icon) {
            <div class="lm-builder-alert-container">
                <div class="lm-builder-alert-header">
                    <p data-automation-id="lm-builder-display-field-icon-alert-header" class="heading">{{ 'IconAlert' | translate }}</p>
                    <a (click)="removeAlert('icon')">
                        <svg id="lm-builder-display-field-icon-alert-remove-icon" data-automation-id="lm-builder-display-field-icon-alert-remove-icon" class="lm-builder-alert-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                    </a>
                </div>
                <div class="field">
                    <label class="required" soho-label for="lm-display-field-icon-alert-when">{{ 'ShowWhen' | translate }}</label>
                    <input
                            id="lm-display-field-icon-alert-when"
                            data-automation-id="lm-display-field-icon-alert-when"
                            soho-lookup
                            soho-trackdirty
                            soho-alert
                            data-validate="validateRequired"
                            [click]="lookupIconClick"
                            [(ngModel)]="displayField.alerts.icon.when.condition"
                            (ngModelChange)="conditionValidator$.next({ type: 'icon', simpleCondition: $event })"/>
                </div>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-icon-alert-not-negated"
                       data-automation-id="lm-builder-display-field-icon-alert-not-negated"
                       [value]=false
                       [(ngModel)]="displayField.alerts.icon.when.negated"
                       (ngModelChange)="updateNegated(false, 'icon')"/>
                <label soho-label for="lm-builder-display-field-icon-alert-not-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsTrue' | translate }}</label>
                <input type="radio"
                       class="radio"
                       soho-radiobutton
                       soho-trackdirty
                       id="lm-builder-display-field-icon-alert-negated"
                       data-automation-id="lm-builder-display-field-icon-alert-negated"
                       [value]=true
                       [(ngModel)]="displayField.alerts.icon.when.negated"
                       (ngModelChange)="updateNegated(true, 'icon')"/>
                <label soho-label for="lm-builder-display-field-icon-alert-negated" [forRadioButton]="true" class="lm-radio-button-label">{{ 'IsFalse' | translate }}</label>
                <div class="field">
                    <label soho-label for="lm-display-field-icon-alert-mouse-over-text">{{ 'Message' | translate }}</label>
                    <input
                            id="lm-display-field-icon-alert-mouse-over-text"
                            data-automation-id="lm-display-field-icon-alert-mouse-over-text-input"
                            soho-input
                            soho-trackdirty
                            class=""
                            [(ngModel)]="iconAlertMessage"
                            (ngModelChange)="updateMessage('icon')">
                </div>
<!--                <div class="field">-->
<!--                    <input-->
<!--                            soho-checkbox-->
<!--                            type="checkbox"-->
<!--                            id="lm-builder-display-field-icon-alert-negate"-->
<!--                            data-automation-id="lm-builder-display-field-icon-alert-negate-input"-->
<!--                            soho-trackdirty-->
<!--                            [(ngModel)]="displayField.alerts.icon.when.negated">-->
<!--                    <label soho-label for="lm-builder-display-field-icon-alert-negate" [forCheckBox]="true" data-automation-id="lm-builder-display-field-icon-alert-negate-label">Show when false</label>-->
<!--                </div>-->
            </div>
        }
    }
</div>
